import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotUpdateQuoteException extends QuoteException {

}